module.exports = __webpack_public_path__ + "static/media/Tag-1.d0b3481f.png";